/**
 * @fileoverview Business-association membership radios and association name field.
 */

import { shouldHideFieldForProfile } from "../../../utils/common";
import styles from "./Certifications.module.css";

const BusinessAssociationField = ({
  section,
  company,
  selectedProfile,
  isTablet,
  isMobile,
}) => {
  const {
    t,
    isMemberOfBusinessAssociation,
    handleRadioChange,
    handleInputChange,
  } = section;

  return (
    !shouldHideFieldForProfile(
      "perteneceAUnaAsociacionEmpresarial",
      selectedProfile,
    ) && (
      <div className={styles.inputRow}>
        <div
          className={`${styles.inputGroup} ${
            isTablet ? styles.tabletGroup : ""
          }`}
        >
          <label className={styles.inputLabel}>
            {t(
              "components.certifications.isMemberOfBusinessAssociationLabel",
            )}
          </label>
          <div className={styles.businessAssociationContainer}>
            <div className={styles.radioGroup}>
              <div className={styles.radioOption}>
                <input
                  type="radio"
                  id="isMemberOfBusinessAssociationNo"
                  name="isMemberOfBusinessAssociation"
                  value={false}
                  checked={isMemberOfBusinessAssociation === false}
                  onChange={() =>
                    handleRadioChange(
                      "perteneceAUnaAsociacionEmpresarial",
                      false,
                    )
                  }
                  className={styles.radio}
                />
                <label
                  htmlFor="isMemberOfBusinessAssociationNo"
                  className={styles.radioLabel}
                >
                  {t(
                    "components.certifications.isMemberOfBusinessAssociationNo",
                  )}
                </label>
              </div>
              <div
                className={`${styles.radioOption} ${
                  isMobile ? styles.radioOptionMobile : ""
                }`}
              >
                <input
                  type="radio"
                  id="isMemberOfBusinessAssociationYes"
                  name="isMemberOfBusinessAssociation"
                  value={true}
                  checked={isMemberOfBusinessAssociation === true}
                  onChange={() =>
                    handleRadioChange(
                      "perteneceAUnaAsociacionEmpresarial",
                      true,
                    )
                  }
                  className={`${styles.radio} ${styles.radioYes}`}
                />
                <label
                  htmlFor="isMemberOfBusinessAssociationYes"
                  className={styles.radioLabel}
                >
                  {t(
                    "components.certifications.isMemberOfBusinessAssociationYes",
                  )}
                </label>
              </div>
            </div>

            {isMemberOfBusinessAssociation === true && (
              <div className={styles.whichAssociationContainer}>
                <label
                  className={`${styles.inputLabel} ${styles.businessAssociationLabel}`}
                >
                  {t(
                    "components.certifications.isMemberOfBusinessAssociationWhich",
                  )}
                </label>
                <input
                  type="text"
                  className={`${styles.input} ${styles.whichAssociationInput}`}
                  placeholder={t(
                    "components.certifications.isMemberOfBusinessAssociationPlaceholder",
                  )}
                  value={company?.asociacionEmpresarial || ""}
                  onChange={(e) => {
                    company.asociacionEmpresarial = e.target.value;
                    handleInputChange(
                      "asociacionEmpresarial",
                      e.target.value,
                    );
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default BusinessAssociationField;
